import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "./ui/card";
import { Button } from "./ui/button";
import { Link } from "react-router-dom";
import { 
  Image, 
  Package2, 
  Building2, 
  Info, 
  Building, 
  MessageSquare, 
  Mail, 
  Star, 
  Award,
  Hotel
} from "lucide-react";

const quickActions = [
  { title: "Manage Hero Section", description: "Update homepage hero images and content", path: "/admin/hero", icon: Image },
  { title: "Manage Packages", description: "Add, edit, or remove travel packages", path: "/admin/packages", icon: Package2 },
  { title: "Manage Services", description: "Update available services", path: "/admin/services", icon: Building2 },
  { title: "About Section", description: "Edit about us content", path: "/admin/about", icon: Info },
  { title: "Company Info", description: "Update company details and addresses", path: "/admin/company", icon: Building },
  { title: "Social Media", description: "Manage social media links", path: "/admin/social", icon: MessageSquare },
  { title: "Messages", description: "View contact messages and quote requests", path: "/admin/messages", icon: Mail },
  { title: "Reviews", description: "Manage customer reviews", path: "/admin/reviews", icon: Star },
  { title: "Why Choose Us", description: "Edit reasons to choose your service", path: "/admin/why-choose-us", icon: Award },
  { title: "Accommodations", description: "Manage accommodation listings", path: "/admin/accommodations", icon: Hotel }
];

export function DashboardHome() {
  return (
    <div className="max-w-7xl mx-auto">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-foreground">Admin Dashboard</h1>
        <p className="text-muted-foreground mt-2">
          Manage your website content and settings from this central location.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {quickActions.map((action) => (
          <Card key={action.path} className="hover:shadow-md transition-shadow">
            <CardHeader>
              <CardTitle className="flex items-center gap-3">
                <action.icon className="h-5 w-5 text-primary" />
                {action.title}
              </CardTitle>
              <CardDescription>{action.description}</CardDescription>
            </CardHeader>
            <CardContent>
              <Button asChild className="w-full">
                <Link to={action.path}>Manage</Link>
              </Button>
            </CardContent>
          </Card>
        ))}
      </div>

    </div>
  );
}